export default __webpack_public_path__ + "static/media/flamingo1.d67a4042.jpg";